<mat-form-field [appearance]="mergedConfig.appearance!" class="custom-date">
  @if (mergedConfig.label) {
    <mat-label>{{ mergedConfig.label | translate }}</mat-label>
  }
  <mat-select
    [panelClass]="mergedConfig.panelClass!"
    [(ngModel)]="selectedItemIds"
    multiple
    (openedChange)="onDropdownOpenedChange($event)"
    (selectionChange)="syncSelectedIds()"
    [placeholder]="mergedConfig.placeholder! | translate"
    [disabled]="mergedConfig.disabled!"
  >
    <mat-select-trigger>
      {{ getSelectedItemIds().length }} {{ 'messages.cmeApproval.selected' | translate }}
    </mat-select-trigger>

    <!-- Ghost options to maintain form value -->
    @for (id of selectedItemIds; track id) {
      <mat-option [value]="id" class="ghost-option"></mat-option>
    }

    <!-- Container option with all hierarchical items -->
    <mat-option class="container-option" (click)="$event.stopPropagation()">
      @for (item of items; track item.id) {
        <div class="entity-group">
          <mat-checkbox
            disableRipple
            [(ngModel)]="item.selected"
            [ngModelOptions]="{ standalone: true }"
            [indeterminate]="isIndeterminate(item)"
            (change)="toggleItemSelection(item, $event.checked)"
            (click)="$event.stopPropagation()"
          >
            {{ item.name }}
          </mat-checkbox>

          @if (item.children?.length) {
            <button mat-icon-button (click)="$event.stopPropagation(); item.expanded = !item.expanded">
              <mat-icon>{{ item.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          }
        </div>

        <!-- Sub-items -->
        @if (item.expanded) {
          @for (child of item.children; track child.id) {
            <div class="sub-entity">
              <mat-checkbox
                [(ngModel)]="child.selected"
                [ngModelOptions]="{ standalone: true }"
                (change)="updateParentSelection()"
                (click)="$event.stopPropagation()"
              >
                {{ child.name }}
              </mat-checkbox>
            </div>
          }
        }
      }
    </mat-option>
  </mat-select>
  <div>
    @if (mergedConfig.showError) {
      <mat-error>
        {{ mergedConfig.errorMessage! | translate }}
      </mat-error>
    }
  </div>
</mat-form-field>

<!-- Error message displayed outside mat-form-field -->
